<template>
  <div
    class="cf-checkbox-input"
    :class="{
      'cf-checkbox-input--vertical': vertical,
      'cf-checkbox-input--icon-box': radioStyle === 'icon-box',
      'cf-checkbox-input--box': radioStyle === 'box',
      'cf-checkbox-input--box-small': radioStyle === 'box-small',
      'cf-checkbox-input--box-small-dynamic': radioStyle === 'box-small-dynamic',
      'cf-checkbox-input--box-grid': radioStyle === 'box-grid',
      'cf-checkbox-input--default': radioStyle === 'default',
      'cf-checkbox-input--has-label': labelStyle !== 'hidden',
      'cf-checkbox-input--radio': radioStyle === 'default'
    }"
  >
    <template v-if="labelStyle !== 'hidden'">
      <h3 class="cf-title cf-title--3 cf-text-align-left">
        {{ label }}

        <span
          v-if="showAsOptional && !validations.required"
          class="cf-subtitle cf-subtitle--3"
        >
          (Optional)
        </span>
      </h3>
    </template>

    <div class="cf-checkbox-input__options">
      <div
        v-for="(option, index) in options"
        :key="option.value"
        class="cf-checkbox-input__option"
      >
        <input
          v-if="index === 0"
          :id="name + index"
          v-model="val"
          :disabled="option.disabled"
          :name="name"
          :value="option.value"
          class="cf-checkbox-input__input"
          type="radio"
          @click="optionClickHandler(option)"
        >

        <input
          v-else
          :id="name + index"
          v-model="val"
          :disabled="option.disabled"
          :name="name"
          :value="option.value"
          class="cf-checkbox-input__input"
          type="radio"
          @click="optionClickHandler(option)"
        >

        <label
          :for="name + index"
          class="cf-checkbox-input__label"
        >
          <!-- <div
            v-if="option.icon && radioStyle === 'icon-box'"
            class="cf-checkbox-input__icon"
          >
            <span :class="`cf-icon cf-icon--med fas primary ${option.icon}`" />
          </div> -->

          <span class="cf-checkbox-input__label-text">
            <span
              v-if="option.icon && radioStyle === 'box'"
              :class="`cf-icon cf-icon--bigger ${option.icon}`"
            />

            <template v-else-if="option.display">
              {{ option.display }}
            </template>

            <span
              v-if="option.subDisplay"
              class="cf-checkbox-input__label-sub-text"
            >
              {{ option.subDisplay }}
            </span>
          </span>
        </label>
      </div>
    </div>

    <cf-input-error :error="errorMessage ? 'An option must be selected.' : null" />
  </div>
</template>


<script>
  import { watch } from 'vue';
  import { useField } from 'vee-validate';

  import CfInputError from '@/view/components/shared/cf-input-error/index.vue';


  export default {
    name: 'CfRadioInput',

    components: {
      CfInputError
    },

    props: {
      allowUncheck: {
        type: Boolean,
        default: false
      },

      label: {
        type: String,
        required: true
      },

      labelStyle: {
        type: String,
        default: ''
      },

      name: {
        type: String,
        required: true
      },

      options: {
        type: Array,
        required: true
      },
      // [
      //   {
      //     value: string | number | boolean,
      //     display: string,
      //     subDisplay: [string],
      //     disabled: [boolean],
      //     icon: [string]
      //   }
      // ]

      radioStyle: {
        type: String,
        default: 'default'
      },
      // 'box' | 'box-small' | 'icon-box' | 'default'

      showAsOptional: {
        type: Boolean,
        default: false
      },

      validations: {
        type: Object,
        default() {
          return {};
        }
      },

      modelValue: {
        type: [String, Number, Boolean],
        default: null
      },

      vertical: {
        type: Boolean,
        default: false
      }
    },

    // VeeValidate 4 requires the Composition API to register a field with the parent form context.
    // setup() is used exclusively for that purpose — all other component logic
    // remains in the Options API below.
    // Exposes: errorMessage (reactive validation error string, undefined when valid)
    // Note: handleChange is used internally by the watch() below and is not exposed.
    setup(props) {
      const { errorMessage, handleChange } = useField(() => props.name, () => props.validations, {
        initialValue: props.modelValue,
        label: props.label
      });

      watch(() => props.modelValue, handleChange);

      return { errorMessage };
    },

    computed: {
      val: {
        get() {
          return this.modelValue;
        },

        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    },

    methods: {
      optionClickHandler(option) {
        if (this.allowUncheck && option.value === this.modelValue) {
          this.$emit('update:modelValue', null);
        }
      }
    }
  };
</script>
